import PropTypes from 'prop-types';
import { useContext } from 'react';
import ThemeContext from '../../../../providers/ThemeProvider';

const BookingCalendarStep = ({ stepIndex, title, children }) => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <div className="step">
        <p className="step-title">
          {stepIndex && <span className="step-index">{stepIndex}</span>}
          {title}
        </p>
        {children}
      </div>
      <style jsx>{`
        .step {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 8px;
        }
        .step-title {
          margin: 0;
          font-weight: bold;
        }
        .step-index {
          background-color: ${theme.colors.primary};
          border-radius: 50%;
          color: ${theme.colors.white};
          display: inline-block;
          font-weight: bold;
          height: 20px;
          margin-right: 5px;
          text-align: center;
          width: 20px;
        }
      `}</style>
    </>
  );
};

BookingCalendarStep.propTypes = {
  children: PropTypes.node,
  stepIndex: PropTypes.string,
  title: PropTypes.string.isRequired,
};

export default BookingCalendarStep;
